module.exports = __webpack_public_path__ + "img/avatar-default-color.afe6557.svg";